import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import NoData from '@/components/NoData/NoData';
import { valsubstr32addbr } from '@/utils/index';
export default {
  components: {
    NoData: NoData
  },
  data: function data() {
    return {
      total: 0,
      pageNum: 1,
      showLoading: false,
      tableData: [],
      tableHeight: 'calc(100vh - 278px)'
    };
  },
  mounted: function mounted() {
    this.getApplicationList();
  },
  methods: {
    getApplicationList: function getApplicationList() {
      var _this = this;
      var pageNum = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var pageSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
      this.$API.getRequest({
        url: '/platform/appliedRole/list',
        data: {
          pageNum: pageNum,
          pageSize: pageSize
        }
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this.tableData = Array.isArray(res.result.records) && res.result.records;
          _this.total = res.result.total;
        }
      });
    },
    currentChange: function currentChange(value) {
      this.pageNum = value;
      this.getApplicationList(this.pageNum, this.pageSize);
    },
    sizeChange: function sizeChange(value) {
      this.pageNum = 1;
      this.pageSize = value;
      this.getApplicationList(this.pageNum, this.pageSize);
    },
    apply: function apply(_ref) {
      var row = _ref.row;
      // window.open(row.applicationUrl)
      var parsedUrl = new URL(row.applicationUrl);
      window.open(decodeURIComponent("".concat(window.location.origin, "/?newPage=").concat(parsedUrl.origin, "&menuPath=").concat(parsedUrl.pathname).concat(parsedUrl.search)));
    },
    ToBreak: function ToBreak(val) {
      if (val) {
        return valsubstr32addbr(val);
      }
    }
  }
};